import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { VersionService } from '../../version-service';

/**
 * This component is the base layout for all other layout components.
 */
@Component({
	selector: 'cc-base-layout',
	templateUrl: './base-layout.component.html',
	styleUrls: ['./base-layout.component.css']
})
export class BaseLayoutComponent implements OnInit, OnDestroy {
	/**
	 * Site hash check interval (in milliseconds)
	 */
	private VERSION_CHECK_INTERVAL: number = 300000;

	/**
	 * Subscription for constantly checking the server version
	 */
	private _VersionCheckSubscription: Subscription;

	constructor(private _VersionService: VersionService) { }

	/**
	 * Initializes the the timer that checks the server version to
	 * reload if it does not match the client's version.
	 */
	ngOnInit(): void {
		this._VersionCheckSubscription = interval(this.VERSION_CHECK_INTERVAL).subscribe(() => {
			this._VersionService.ReloadIfClientUpdateIsAvailable();
		});
	}

	/**
	 * Component destruction.
	 */
	public ngOnDestroy(): void {
		this._VersionCheckSubscription.unsubscribe();
	}
}